import { NotificationsService } from 'angular2-notifications';
import { SchedulingTask, TaskTypeEnum } from './../../../../interfaces/SchedulingTask';
import { FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Component, AfterViewInit, Input, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { SchedulingTaskService } from 'src/app/services/scheduling-task.service';

@Component({
  selector: 'modal-task',
  templateUrl: './modal-task.component.html',
  styleUrls: ['./modal-task.component.scss']
})
export class ModalTaskComponent implements AfterViewInit, OnDestroy {

  @Input() eventOpen: Observable<SchedulingTask>;
  @Output() reloadTasks = new EventEmitter();

  @ViewChild('modal') contentModal: ElementRef;

  constructor(
    private modalService: NgbModal,
    private cdref: ChangeDetectorRef,
    private schedulingTaskService: SchedulingTaskService,
    private notificationsService: NotificationsService
  ) {

  }

  ngOnDestroy(): void {
    this.modalInfo.unsubscribe();
  }

  taskTypes: TaskTypeEnum[] = []

  formTaskType = new FormControl(null, Validators.required);
  formStartTime = new FormControl({ hour: new Date().getHours(), minute: 0 }, Validators.required);
  formStatusTask = new FormControl(null);
  formTaskId = new FormControl(null);
  formLastRun = new FormControl(null);

  waitingHours = 1;

  modalInfo: Subscription;
  isNewTask: boolean;

  ngAfterViewInit(): void {
    this.getTypes();

    this.modalInfo = this.eventOpen.subscribe(
      (res: SchedulingTask) => {

        if (res) {
          this.isNewTask = false;

          this.waitingHours = res.waitingHours;
          this.formTaskId.setValue(res.id);
          this.formTaskType.setValue(res.taskType);
          this.formStartTime.setValue({ hour: res.startTime, minute: 0 });
          this.formStatusTask.setValue(res.isActive);
          this.formTaskType.disable();
          this.cdref.detectChanges();
        }
        else {
          this.isNewTask = true;
          this.formTaskType.enable();
        }

        //Busco o que preciso, Valido
        this.openModal();
      }
    )
  }

  getTypes() {
    this.schedulingTaskService.getTypes().subscribe(res => {
      this.taskTypes = res;
    })
  }

  openModal() {
    this.modalService.open(this.contentModal, { size: 'sm', keyboard: false, backdrop: 'static' });
  }

  closeModal() {
    this.modalService.dismissAll();
    this.formTaskType.reset();
    this.waitingHours = 1;
    this.formTaskId.reset();
    this.formStartTime = new FormControl({ hour: new Date().getHours(), minute: 0 });
    this.formStatusTask.reset();
  }

  save() {

    if (this.formStartTime.invalid || this.formTaskType.invalid) {
      this.notificationsService.alert("Atenção", "Todos os campos devem ser preenchidos");
      return;
    }

    let schedulingTask: SchedulingTask = {
      startTime: this.formStartTime.value.hour,
      taskType: this.formTaskType.value,
      waitingHours: this.waitingHours
    }

    if (this.isNewTask) {

      this.schedulingTaskService.saveNew(schedulingTask).subscribe(res => {
        this.reloadTasks.emit();
      })

    } else {
      schedulingTask.id = this.formTaskId.value;
      schedulingTask.isActive = this.formStatusTask.value;

      this.schedulingTaskService.updateTask(schedulingTask).subscribe(res => {
        this.reloadTasks.emit();
      })
    }
    this.closeModal();
  }

  formatLabel(value: number) {
    return value + 'h';
  }
}
